import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PendingDocumentBanner from "@/components/common/PendingDocumentBanner";
import OffboardingBanner from "@/components/common/OffboardingBanner";
import DailyReportBanner from "@/components/common/DailyReportBanner";
import SubscriptionBanner from "@/components/billing/SubscriptionBanner";
import DeviceNameDialog from "@/components/auth/DeviceNameDialog";
import DesktopAppForceDialog from "@/components/desktop-app/DesktopAppForceDialog";
import { useUIStore } from "@/stores/uiStore";
import { cn } from "@/lib/utils";
import { ChatWebSocketProvider } from "@/contexts/ChatWebSocketContext";
import { usePushNotificationRead } from "@/hooks/usePushNotificationRead";

export default function MainLayout() {
  const { sidebarCollapsed, sidebarOpen, setSidebarOpen } = useUIStore();
  // 푸시 알림 클릭으로 진입 시 ?notif=<id> 를 읽어 읽음 처리
  usePushNotificationRead();

  return (
    <ChatWebSocketProvider>
      <div className="main-layout">
        {/* Mobile overlay */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-40 bg-black/50 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <aside
          className={cn(
            "sidebar fixed z-50 transition-all duration-300 lg:relative lg:z-auto",
            sidebarCollapsed ? "lg:w-16" : "lg:w-64",
            sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
          )}
        >
          <Sidebar />
        </aside>

        {/* Main content area */}
        <div className="main-content">
          <Header />
          <PendingDocumentBanner />
          <OffboardingBanner />
          <DailyReportBanner />
          <SubscriptionBanner />
          <main className="page-container scrollbar-thin p-4 md:p-6">
            <Outlet />
          </main>
        </div>
      </div>
      <DeviceNameDialog />
      {/* Windows 메신저 설치 안내 모달 — 강제 대상자가 헤더 메신저 아이콘을 눌렀을 때만 열림 */}
      <DesktopAppForceDialog />
    </ChatWebSocketProvider>
  );
}
